import React from 'react';
import StarOutlineRoundedIcon from '@material-ui/icons/StarOutlineRounded';
import { LinkProps } from '@material-ui/core/Link';

import HistoriesImage from '../../images/header/history.png';
import {
  ABOUT,
  BUSINESS,
  BUSINESSES,
  EXPERIENCE,
  FAVORITE_PLANS,
  PLANS,
  USER_HISTORIES,
} from '../../constants/routing';

export const TOOLBAR_SM_MIN_HEIGHT = 52;
const SUBHEADER_MIN_HEIGHT = 60;
export const HEADER_MIN_HEIGHT = 64 + SUBHEADER_MIN_HEIGHT;

export const getMenus = (
  t,
): {
  ['about' | 'plans' | 'businesses' | 'diary' | 'business']: LinkProps,
} => ({
  about: { href: ABOUT, children: t('header.about') },
  plans: { href: PLANS, children: t('header.plans') },
  businesses: { href: BUSINESSES, children: t('header.businesses') },
  diary: { href: EXPERIENCE, children: t('header.diary') },
  business: {
    href: BUSINESS,
    children: t('header.business'),
    id: 'business_gnavi',
    'data-turbolinks': false,
    target: '_blank',
  },
});

// Menus positioned on Header and Account Menu by the device size
export const getDynamicMenus = (
  t,
): Array<{
  href: string,
  src?: string,
  icon: React.ComponentType,
  text: React.ReactNode,
}> => [
  {
    href: FAVORITE_PLANS,
    icon: StarOutlineRoundedIcon,
    text: t('header.menu.favoritePlans'),
  },
  {
    href: USER_HISTORIES,
    src: HistoriesImage,
    text: t('header.menu.histories'),
  },
];

export const getMinHeight = (theme) =>
  theme.mixins.toolbar.minHeight + theme.spacing(1);

export const getLinkStyles = (
  theme,
  {
    underline = false,
    color,
    hoverColor = color,
  }: { underline?: boolean, color?: string, hoverColor?: string } = {},
) => ({
  color: `${color} !important`,
  fontSize: theme.typography.pxToRem(15),
  backgroundColor: 'transparent',
  '&:hover': {
    color: `${hoverColor} !important`,
    backgroundColor: 'transparent',
    ...(!underline && { textDecoration: 'none' }),
  },
  '&:focus': {
    backgroundColor: 'transparent',
  },
});
